var CategoryToCategory = Barba.BaseTransition.extend({

    start: function() {

        /**
         * This function is automatically called as soon the Transition starts
         * this.newContainerLoading is a Promise for the loading of the new container
         * (Barba.js also comes with an handy Promise polyfill!)
         */

        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
        /**
         * this.oldContainer is the HTMLElement of the old Container
         */


        //animate out categories
        let tl =  anime.timeline({
            easing: 'easeInOutCubic',
            // duration: 1000,
        })

        tl.add({
            targets: '.product-archive .album-container',
            duration: 500,
            opacity: 0,
            scale: .7,
            easing: 'easeInCubic',
            delay: anime.stagger(50)
        })
        tl.add({
            targets: '.product-archive .header-container',
            duration: 500,
            opacity: [1, 0],
            easing: 'easeOutCubic'
        },'-=500')

        // tl.add({
        //     targets: this.oldContainer,
        //     opacity: 0,
        // },500)

        return tl.finished.then();




    },

    fadeIn: function() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        var _this = this;
        var $el = $(this.newContainer);

        $(this.oldContainer).hide();

        $el.css({
            visibility : 'visible',
            opacity : 1
        });

        let tl =  anime.timeline({
            easing: 'easeInOutCubic',
            duration: 1000,
        })

        tl.add({
            targets: '.product-archive .album-container',
            duration: 500,
            opacity: [0, 1],
            scale: [.7, 1],
            easing: 'easeOutCubic',
            delay: anime.stagger(50)
        })
        tl.add({
            targets: '.product-archive .header-container',
            duration: 500,
            opacity: [0, 1],
            easing: 'easeOutCubic'
        },100)




        $el.animate({ opacity: 1 }, 10, function() {
            /**
             * Do not forget to call .done() as soon your transition is finished!
             * .done() will automatically remove from the DOM the old Container
             */

            _this.done();
        });
    }
});
